<template>
  <div class="col-md-12 webshop-single-product">
    <div v-if="!(woocommerceIntegration == 1 && viewingProduct > 0)" class="row mt-3 ">
      <breadcrumb :navPath="navPath" @navigate="handleNavigation" />
    </div>

    <div class="row webshop-single-product-item mt-3 ">
      <div class="col-md-6 display-section">
        <img :src="thumbImage" class="img-fluid" alt="" />
        <br />
        <h5 class="title mt-4">{{ $t(LangConstants.general_information_text) }}</h5>
        <p class="information-content" v-if="$props.course.courseInstance.summary" v-html="$props.course.courseInstance.summary"></p>
        <p class="information-content" v-if="!$props.course.courseInstance.summary">
          {{ $t(LangConstants.information_not_available_text) }}
        </p>
      </div>

      <div class="col-md-6 purchse-section">
        <div class="title">{{ $props.course.courseInstance.name }}</div>
        <div class="secure-trans mt-3 mb-3"><i class="fa fa-shield mr-2 mt-2"></i>{{ $t(LangConstants.secure_transaction_text) }}</div>

        <div class="row purchse-information">
          <div class="col-md-6 purchaseinfo-item">
            <div class="purchaseinfo-title">{{ $t(LangConstants.sold_through_text) }}</div>
            <p class="description">{{ $t(LangConstants.autotech_development_text) }}</p>
          </div>
          <div class="col-md-6 purchaseinfo-item">
            <div class="purchaseinfo-title">{{ $t(LangConstants.provided_by_text) }}</div>
            <p class="description">
              {{ this.$props.course.customer ? this.$props.course.customer.name : "" }}
            </p>
          </div>

          <div class="col-md-12 purchaseinfo-item">
            <div class="purchaseinfo-title">{{ $t(LangConstants.return_policy_text) }}</div>
            <p class="description">
              {{ $t(LangConstants.not_eligible_for_return_text) }}
            </p>
          </div>

          <!-- <div class="col-md-12 purchaseinfo-item">
            <div class="purchaseinfo-title">{{ $t(LangConstants.support_text) }}</div>
            <p class="description">{{ $t(LangConstants.free_support_plan_included) }}</p>
          </div> -->
        </div>

        <div class="row mb-3" v-if="priceItems.length == 0">
          <div class="col-md-6">
            <div class="course-price">{{ formattedPrice }}</div>
          </div>
        </div>

        <!-- <div v-if="priceItems.length == 0" class="mb-3 course-price">{{ formattedPrice }}</div> -->
        <div v-if="priceItems.length > 0" class="mb-3 "><my-table :fields="fields" :items="priceItems"></my-table></div>

        <div class="row" v-if="course.courseInstance.type != 'instructor_led_training'">
          <div class="col-md-3">
            <my-input id="slots" name="my-name" inlinerows="false" inlinerowclasses="" inlineLabelClass="" inlineInputClass="" classes="bg-gray" type="number" v-model="eLearningCourseQuantity" ref="quantity" :defaultText="1" :minLength="1"></my-input>
          </div>
          <div class="col">
            <my-button v-if="!loginUrl" :label="$t(LangConstants.buy_button_label)" variant="solid-primary" classes="course-buy-btn" height="48px" fa="shopping-cart" :link="isPreview == false ? '#' : false" @onClick="buyCourse"></my-button>
         
            <my-button v-if="loginUrl" :label="$t(LangConstants.login_to_view_pricing)" variant="solid-primary" classes="course-buy-btn" height="48px" fa="" :link="loginUrl" target="_top"></my-button>
          </div>
        </div>

        <p class="mt-3 license-notice">{{ $t(LangConstants.licenses_available_days) }}</p>

        <hr class="mt-4 mb-4" />

        <div class="row item-features">
          <div class="col-md-4 feature-item">
            <div class="feature-title">{{ $t(LangConstants.type_placeholder) }}</div>
            <p class="feature-descripion">{{ $t(courseType) }}</p>
          </div>
          <div class="col-md-4 feature-item">
            <div class="feature-title">{{ $t(LangConstants.languages_placeholder) }}</div>
            <p class="feature-descripion">{{ languages }}</p>
          </div>
          <div class="col-md-4 feature-item">
            <div class="feature-title">{{ $t(LangConstants.length_text) }}</div>
            <p class="feature-descripion">{{ totalDuration }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="row course-events-container" v-if="course.courseInstance.type == 'instructor_led_training'">
      <course-events :events="courseEvents" :course="course" :isPreview="isPreview" :signInLink="loginUrl" />
    </div>
  </div>
</template>

<script>
import "../../assets/scss/shopcourseitempreview.scss";
import Breadcrumb from "../atoms/Breadcrumb.vue";
// import Selector from "../atoms/Selector.vue";
import MyButton from "../atoms/Button.vue";
import MyTable from "../atoms/Table.vue";
import MyInput from "../atoms/Input.vue";
import CourseEvents from "./CourseEvents.vue";
import Common from "../../functions/index";
import Constants from "../../constants/index";
const dayjs = require("dayjs");

export default {
  name: "shop-course-item-preview",

  props: {
    course: {
      type: Object,
      required: true,
    },

    isPreview: {
      type: Boolean,
      default: false,
    },
  },

  data: function() {
    return {
      navPathProp: [
        { text: this.$t(Constants.shop_text), href: "back", active: true },
        { text: "Shop Item", href: "#" },
      ],
      eLearningCourseQuantity: 1,
      showingCourse: 0,
      product_id: 0,
    };
  },

  setup() {},
  created() {
    this.product_id = this.$route.params.product_id ? this.$route.params.product_id : 0;
    //  alert("scip");
    // alert(this.$props.course);
  },
  methods: {
    handleNavigation(href) {
      this.$emit("navigate", href);
    },
    buyCourse() {
      const session_id = this.$route.query.session_key ? this.$route.query.session_key : 0;
      const quantity = this.eLearningCourseQuantity;
      window.parent.location = this.$store.getters.instanceUrl + "v/company-account/webshop/" + this.$props.course.courseid + "/" + this.$props.course.instance_id + "/" + session_id + "?quantity=" + quantity;
    },

    setNavPath() {
      this.navPathProp[1].text = this.$props.course.courseInstance.name;
    },
  },

  computed: {
    viewingProduct() {
      return this.product_id;
    },
    woocommerceIntegration() {
      const settings = this.$store.getters.generalSettings;
      if (settings != null && settings.instanceSettings.woocommerce_integration == 1) {
        return true;
      }
      return false;
    },
    // courseX() {
    //   return this.course;
    // },
    navPath() {
      this.setNavPath();
      return this.navPathProp;
    },

    fields() {
      return ["Quantity", "Price"];
    },
    priceItems() {
      if ("prices" in this.$props.course && this.$props.course.prices.length > 0) {
        let priceChart = [];

        for (let i = 0; i < this.$props.course.prices.length; i++) {
          const qties = "" + this.$props.course.prices[i]["from"] + (this.$props.course.prices[i]["to"] != null ? " - " + this.$props.course.prices[i]["to"] : " +");
          const price = Common.formatMoney(this.$props.course.prices[i]["price"] / 100, this.course.currency);
          const obj = { Quantity: qties, Price: price };
          priceChart.push(obj);
        }
        return priceChart;
      }

      return [];
    },
    formattedPrice() {
      if (this.$props.course) {
        return Common.formatMoney(this.$props.course.price, this.course.currency);
      } else {
        return "00.00";
      }
    },
    loginUrl(){
      // check if signedIn property of the course object is set and if its set to false, if set to false return this.course.signInLink. else return false
      if (this.$props.course.signedIn == false) {
        return this.$props.course.signInLink;
      } else {
        return false;
      }
    },
    thumbImage() {
      if (this.$props.course.courseInstance.image == null) {
        return Common.getImagefromContext("placeholder");
      } else {
        return this.$props.course.courseInstance.image;
      }
    },

    totalDuration() {
      return Common.timeConvert(this.$props.course.courseInstance.duration);
    },

    courseType() {
      const courseTypes = this.$store.getters.courseTypes;

      let courseType = null;

      if (this.$props.course.courseInstance.type) {
        // console.log(this.$props.course.courseInstance);

        courseType = courseTypes.find((ct) => ct.type_id == this.$props.course.courseInstance.type);
        courseType = courseType.type_name;
      } else {
        courseType = this.$t(Constants.not_available_short_text);
      }

      return courseType;
    },

    languages() {
      // console.log(this.$props.course);

      return this.$props.course.languages
        ? JSON.parse(this.$props.course.languages)
            .map((lang) => Constants.isoLangs.find(langObj => langObj.name == lang.name).nativeName)
            .join(", ")
        : this.$t(Constants.not_available_short_text);
    },

    findNativeNameOflanguage(languageName) {
      const language = Constants.isoLangs.find(lang => lang.name == languageName);
      return language ? language.nativeName : null;
    },

    LangConstants() {
      return Constants;
    },

    courseEvents() {
      // return this.course.courseEvents;
      //  && dayjs().isAfter(event.published_date) && dayjs().isAfter(event.last_registration_date)
      if (this.course.courseEvents) {
        return this.course.courseEvents.filter(function(event) {
          // if (event.published == true && dayjs().isAfter(event.publish_date) && dayjs().isBefore(event.last_registration_date)) {
          return event;
          // }
        });
      } else {
        return this.course.courseInstance.course_event.filter(function(event) {
          if (event.published == true && dayjs().isAfter(event.publish_date) && dayjs().isBefore(event.last_registration_date)) {
            return event;
          }
        });
      }
    },
  },

  components: {
    Breadcrumb,
    MyButton,
    CourseEvents,
    MyTable,
    MyInput,
  },
};
</script>
